<template>
    <div class="p-index__content l-content l-result">
        <div class="l-post">
            <p class="c-date u-mb25-pc u-mb15-sp">{{ informationDetail[0].format_date }}</p>
            <h2>{{ informationDetail[0].INFO_TITILE }}</h2>
            <div class="l-entry"><p><span v-html="informationDetail[0].INFO_DESCRIPTION"></span></p></div>
            <div v-if="informationDetail[0].info_image_path != null && informationDetail[0].LINK_URL != null">
                <a :href="informationDetail[0].LINK_URL" target="_self">
                    <img :src="informationDetail[0].info_image_path" style="width: 100%" alt="" loading="lazy">
                </a>
            </div>
            <div v-if="informationDetail[0].info_image_path != null && informationDetail[0].LINK_URL == null">
                <img :src="informationDetail[0].info_image_path" style="width: 100%" alt="" loading="lazy">
            </div>
        </div>
        <div class="u-text-center" v-if="!isIndividualNotice">
            <div class="c-btn-normal1"><a :href="route(route_list, 'site.information')">お知らせ一覧</a></div>
        </div>
        <div class="u-text-center" v-if="isIndividualNotice">
            <div class="c-btn-normal1"><a :href="route(route_list, 'site.information.important')">重要なお知らせ一覧</a></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
    props: [
        'informationDetail',
        'route_list',
        'isIndividualNotice'
    ],
    mixins: [routeMixin],
    data () {
        return {}
    },
    computed: {
        windowWidth() {
            return this.getWindowWidth();
        }
    },
    mounted(){
        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth());
        })
    },
    methods:{
        getWindowWidth(event) {
            let breakpoint = document.documentElement.clientWidth;
            if(breakpoint < 767){
                this.isShow = true;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.c-slider-news__item::before{
    display: none;
}
.c-slider-news__img{
    @media screen and (min-width: 768px) {
        border: none;
    }
}
.l-result{
    padding: 0 0 100px;
    @media screen and (max-width: 767px) {
        padding: 0 0 55px;
    }
    .c-column-bg{
        margin: 0 0 40px;
        @media screen and (min-width: 768px) {
            padding-left: 0;
            padding-right: 0;
        }
        @media screen and (max-width: 767px) {
            width: auto;
            margin: 0 -15px 25px;
        }
    }
}
.l-post{
    font-size: 12px;
    line-height: 1.5;
    padding: 0 0 20px;
    h2{
        padding: 0;
        height: auto;
        display: block;
        text-align: center;
        color: #00b3d6;
        line-height: 1.3;
        @media screen and (min-width: 768px) {
            font-size: 2.2rem;
        }
        &::before{
            display: none;
        }
    }
    .l-entry{
        p{
            margin: 0 0 20px;
            &.u-f13{
                font-size: 13px;
            }
        }
    }
}
</style>
<style lang="scss">
    .l-post .l-entry > p a {
        color: #06c;
        display: inline-block;
        text-decoration: underline;
    }
</style>
